<template>
  <v-list
    two-line
    dense
  >
    <v-list-group append-icon>
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title class="title my-2">{{ $t('Items') }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ order.summary.total_items_count }} {{ $t('items') }}</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-icon>keyboard_arrow_down</v-icon>
      </v-list-tile>

      <v-subheader
        v-if="order.unfulfilled.length"
        class="subheading mt-2">{{ $t('Unfulfilled') }}</v-subheader>

      <LineItems :items="order.unfulfilled"/>

      <v-subheader
        v-if="order.shipped.length"
        class="subheading mt-3"
      >
        {{ $t('Shipped') }}
      </v-subheader>
      <template
        v-for="(shipment, index) in order.shippedui"
      >
        <v-subheader
          :key="`head-${index}`"
          class="caption primary lighten-2 pt-2">
          {{ $t('Shipped by {0}', [shipment.carrier]) }}
          (<router-link
            to="#"
          >
            #{{ shipment.tracking_number }}
          </router-link>)
        </v-subheader>

        <LineItems
          :key="`line-head-${index}`"
          :items="shipment.items"
        />

      </template>
    </v-list-group>
  </v-list>
</template>

<script>
import LineItems from '../Items/LineItems'

export default {
  name: 'OrderSingleSummarItems',

  components: {
    LineItems
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>
